const predictMobile = () => window.matchMedia('(max-width: 30rem)').matches;

export default predictMobile;
